class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.handleOverlayClick = this.close.bind(this);
    this.handleCloseButtonClick = this.close.bind(this);

    this.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });

    this.bindCartDrawerCloseEvents();
    this.setHeaderCartIconAccessibility();
    this.setfooterCartIconAccessibility();
  }

  bindCartDrawerCloseEvents() {
    const overlay = this.querySelector('#CartDrawer-Overlay');

    if (overlay) {
      overlay.removeEventListener('click', this.handleOverlayClick);
      overlay.addEventListener('click', this.handleOverlayClick);
    }

    this.querySelectorAll('.drawer__close').forEach((button) => {
      button.removeEventListener('click', this.handleCloseButtonClick);
      button.addEventListener('click', this.handleCloseButtonClick);
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  setfooterCartIconAccessibility() {
    const cartLink = document.querySelector('#footer-cart-icon');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');

    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    const overlay = this.querySelector('#CartDrawer-Overlay');

    if (overlay) {
      overlay.removeAttribute('style');
    }

    this.classList.remove('is-closing');

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        if (!this.classList.contains('active')) return;

        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');

        const focusElement =
          this.querySelector('.drawer__inner') ||
          this.querySelector('.drawer__close');

        if (containerToTrapFocusOn && focusElement) {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

close(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  this.classList.remove('active');

  removeTrapFocus(this.activeElement);

  document.body.classList.remove(
    'overflow-hidden',
    'overflow-hidden-mobile',
    'overflow-hidden-tablet',
    'overflow-hidden-desktop'
  );

  document.documentElement.classList.remove(
    'overflow-hidden',
    'overflow-hidden-mobile',
    'overflow-hidden-tablet',
    'overflow-hidden-desktop'
  );

  const overlay = this.querySelector('#CartDrawer-Overlay');

  if (overlay) {
    overlay.classList.remove('active');
    overlay.style.opacity = '0';
    overlay.style.visibility = 'hidden';
    overlay.style.pointerEvents = 'none';
  }

  // Mobile fix: reset menu overlay state that can stay dark
  document.querySelectorAll('.header__icon--menu, summary.header__icon--menu').forEach((button) => {
    button.setAttribute('aria-expanded', 'false');
  });

  document.querySelectorAll('header-drawer details[open]').forEach((details) => {
    details.removeAttribute('open');
    details.classList.remove('menu-opening');
  });

  document.querySelectorAll('.menu-opening, .submenu-open, .menu-open').forEach((el) => {
    el.classList.remove('menu-opening', 'submenu-open', 'menu-open');
  });

  setTimeout(() => {
    if (!this.classList.contains('active')) {
      this.classList.remove('animate');

      document.body.classList.remove(
        'overflow-hidden',
        'overflow-hidden-mobile',
        'overflow-hidden-tablet',
        'overflow-hidden-desktop'
      );

      document.documentElement.classList.remove(
        'overflow-hidden',
        'overflow-hidden-mobile',
        'overflow-hidden-tablet',
        'overflow-hidden-desktop'
      );
    }
  }, 450);
}

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (
      cartDrawerNote.nextElementSibling &&
      cartDrawerNote.nextElementSibling.getAttribute('id')
    ) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const drawerInner = this.querySelector('.drawer__inner');

    if (drawerInner && drawerInner.classList.contains('is-empty')) {
      drawerInner.classList.remove('is-empty');
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      if (!parsedState.sections[section.id]) return;

      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.bindCartDrawerCloseEvents();
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const selectedElement = parsedHTML.querySelector(selector);

    return selectedElement ? selectedElement.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'footer-cart-icon',
        section: 'footer-cart-icon',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
/* ============================================================
   FIX: mobile cart drawer parent overlay staying visible after close
   ============================================================ */
(() => {
  const CartDrawerElement = customElements.get('cart-drawer');
  if (!CartDrawerElement) return;

  const originalOpen = CartDrawerElement.prototype.open;

  CartDrawerElement.prototype.open = function(triggeredBy) {
    this.removeAttribute('style');

    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.removeAttribute('style');

    return originalOpen.call(this, triggeredBy);
  };

  CartDrawerElement.prototype.close = function(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.classList.remove('active');

    removeTrapFocus(this.activeElement);

    document.body.classList.remove(
      'overflow-hidden',
      'overflow-hidden-mobile',
      'overflow-hidden-tablet',
      'overflow-hidden-desktop',
      'overflow-hidden-undefined'
    );

    document.documentElement.classList.remove(
      'overflow-hidden',
      'overflow-hidden-mobile',
      'overflow-hidden-tablet',
      'overflow-hidden-desktop',
      'overflow-hidden-undefined'
    );

    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.classList.remove('active');
      overlay.style.opacity = '0';
      overlay.style.visibility = 'hidden';
      overlay.style.pointerEvents = 'none';
      overlay.style.background = 'transparent';
    }

    setTimeout(() => {
      if (!this.classList.contains('active')) {
        this.classList.remove('animate', 'is-closing');
        this.style.visibility = 'hidden';
        this.style.pointerEvents = 'none';
      }
    }, 450);
  };
})();
